/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: dedbc3c2a2a8
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  ExplicitRequest,
  ExplicitRequest$zodSchema,
} from "./explicitrequest.js";
import { ResourceType, ResourceType$zodSchema } from "./resourcetype.js";
import { UploadResponse, UploadResponse$zodSchema } from "./uploadresponse.js";

export type ExplicitAssetGlobals = { cloud_name?: string | undefined };

export const ExplicitAssetGlobals$zodSchema: z.ZodType<ExplicitAssetGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type ExplicitAssetRequest = {
  resource_type: ResourceType;
  explicit_request: ExplicitRequest;
};

export const ExplicitAssetRequest$zodSchema: z.ZodType<ExplicitAssetRequest> = z
  .object({
    explicit_request: ExplicitRequest$zodSchema.describe(
      "The asset and operations to apply.",
    ),
    resource_type: ResourceType$zodSchema.describe(
      "The type of resource (image, video, or raw).",
    ),
  });

export type ExplicitAssetResponse = ApiError | UploadResponse;

export const ExplicitAssetResponse$zodSchema: z.ZodType<ExplicitAssetResponse> =
  z.union([
    ApiError$zodSchema,
    UploadResponse$zodSchema,
  ]);
